import { FC } from "react"
import { OccupationCategory } from "../../../../domain/entities/occupationCategory"
import { BlankStateSection } from "../../../shared/BlankStateSection"
import { CenteredSpinner } from "../../../shared/CenteredSpinner"
import { OccupationCategoryListView } from "./OccupationCategoryListView"

interface Props {
	list: OccupationCategory[]
	isLoading: boolean
	onUpdate: (occupationCategory: OccupationCategory) => void
	onDelete: (occupationCategory: OccupationCategory) => void
	onAddClick: () => void
}

export const OccupationCategoryListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return (
			<BlankStateSection
				message="No OccupationCategories found."
				onAddClick={onAddClick}
			/>
		)
	}

	return (
		<OccupationCategoryListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
	)
}
